import { Chip, Avatar } from '@mui/material';
import './DetailsRequired.css';
import ColorConstants from '../../defaults/ColorConstants';

export default function DetailsRequired({ chipClicked, missingFields }) {
    const missingFieldsMessage = 'Required Fields Missing';

    return (
        <Chip
            className='required-field-status-chip'
            onClick={chipClicked}
            style={{ backgroundColor: `${ColorConstants.AvatarBackgroundColor}` }}
            avatar={
                <Avatar
                    style={{
                        fontSize: '12px',
                        width: '22px',
                        height: '22px',
                        backgroundColor: ColorConstants.AvatarColor,
                        color: ColorConstants.WhiteAlien,
                    }}
                >
                    {missingFields}
                </Avatar>
            }
            label={
                <span style={{ fontSize: '12px', lineHeight: '21px' }}>{missingFieldsMessage}</span>
            }
        />
    );
}
